<template>
  <div class="login-page">
    <!-- <div class="left-area">
      <img src="../../assets/images/icon.png" />
      <span class="el-header__title">柴油卡数据可视化平台</span>
    </div>-->
    <div class="minw">
      <video width="100%" autoplay preload muted loop src="../../assets/images/1.mp4"></video>
    </div>
    <div class="login-wrap" v-if="!disabled">
      <div class="l-title">全国道路运营热力数据平台</div>
      <el-col :class="translateLeft" :span="10" class="login-box">
        <div v-if="notforget">
          <div class="logo">
            <div class="title">
              <a>
                <span>账号登录</span>
              </a>
            </div>
          </div>

          <div class="login-form r-f">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item prop="username">
                <el-input :placeholder="$t('login.userplaceholder')" v-model="ruleForm.username">
                  <template slot="prepend">
                    <icon name="phone" :scale="2"></icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-col :span="15">
                  <el-input
                    :placeholder="$t('login.pwdplaceholder')"
                    type="password"
                    v-model="ruleForm.password"
                    @keyup.enter.native="handleLogin('ruleForm')"
                  >
                    <template slot="prepend">
                      <icon name="message" :scale="2"></icon>
                    </template>
                  </el-input>
                </el-col>
                <el-col :offset="1" :span="4">
                  <el-button v-show="show" @click="getIdentifyingCode">
                    <span>获取验证码</span>
                  </el-button>
                  <el-button v-show="!show">
                    <span class="count">{{count}} s</span>
                  </el-button>
                </el-col>
              </el-form-item>
              <el-form-item class="btn">
                <el-button
                  :loading="loading"
                  type="primary"
                  @click="handleLogin('ruleForm')"
                >{{$t('login.btn')}}</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="login-footer login-footer-s">
            <el-col :span="12">
              <el-checkbox v-model="remember" name="type">{{$t('login.remember')}}</el-checkbox>
            </el-col>
          </div>
        </div>

        <div v-else>
          <div class="title forgetwrap-title">
            <a>
              <span>VUE</span>
              <span class="subtitle">EDEN</span>
            </a>
          </div>
          <div class="forget-form">
            <el-form :model="forgetForm" ref="forgetRuleForm">
              <el-form-item>
                <el-input :placeholder="$t('login.forget_email')" v-model="forgetForm.email"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input :placeholder="$t('login.forget_code')" v-model="forgetForm.code"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  :placeholder="$t('login.forget_passwrd')"
                  type="password"
                  v-model="forgetForm.newPassword"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  :placeholder="$t('login.confirm_passwrd')"
                  type="password"
                  v-model="forgetForm.confirmPassword"
                ></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-button @click="wrapSwitch(true)" type="primary">{{$t('login.forget_back')}}</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button @click="forgetHandle" type="primary">{{$t('login.forget_btn')}}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </div>
    <el-dialog :visible.sync="disabled" @close='closeDialog'>
      <div class="ieDia">
        <div class="ieTl">您的浏览器版本过低</div>
        <div class="ieCon">为了更好的浏览器体验，建议您使用以下现代浏览器的最新版本</div>
        <div class="itPic">
          <img src="../../assets/images/guge.png" />
          <img src="../../assets/images/safari.png" />
          <img src="../../assets/images/hh.png" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import langselect from '@/components/langselect'
import storage from '@/utils/storage'
import { getIdentifyingCodes } from '@/api/login'
import { IEVersion } from '@/utils/tools'
import store from '@/store'
export default {
  name: 'login',
  components: {
    langselect
  },
  created() {
    this.judgeClient()
  },
  mounted() {},
  data() {
    return {
      lang: this.$store.state.app.language,
      ruleForm: {
        username: storage.get('loginUser'),
        password: ''
      },
      rules: {
        username: [
          {
            pattern: /^((13[0-9])|(17[0-9])|(14[5|7])|(15([0-9]))|(16[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
            required: true
          }
        ],
        password: [
          { message: '请输入正确的验证码', trigger: 'blur', required: true }
        ]
      },
      show: true,
      timer: null,
      count: '',
      remember: true,
      loading: false,
      switchLeft: false,
      switchRight: false,
      notforget: true,
      forgetForm: {
        email: '',
        newPassword: '',
        confirmPassword: ''
      },
      disabled: false //是否是IE浏览器
    }
  },
  computed: {
    translateLeft() {
      return {
        'translate-left': true,
        'login-col': true,
        'switch-left': this.switchLeft
      }
    },
    translateRight() {
      return {
        'translate-right': true,
        'login-col': true,
        'switch-right': this.switchLeft
      }
    }
  },
  methods: {
    closeDialog(){
       this.disabled = true
    },
    judgeClient() {
      let client = IEVersion()
      if (client != -1) {
      this.disabled = true
      // this.$alert('<div></div>', '', {
      //   dangerouslyUseHTMLString: true
      // })
      // this.$notify({
      //   title: '登陆提示',
      //   message: '请使用谷歌浏览器',
      //   position: 'top-left',
      //   duration: 0
      // })
      }
    },
    getIdentifyingCode() {
      return new Promise(async (resolve, reject) => {
        try {
          this.getCode()
          const identifyingCode = await getIdentifyingCodes(
            this.ruleForm.username
          )
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    getCode() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    handleLogin(formName) {
      this.loading = true
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            let { username, password } = this.ruleForm
            this.remember
              ? storage.set('loginUser', username)
              : storage.remove('loginUser', username)
            storage.set('password', password)
            const response = await this.$store.dispatch('loginbyUser', {
              username: username,
              password: password
            }) //返回登陆成功后的参数
            this.loading = false
            if (response.data) {
              this.$notify.closeAll()
              this.$router.push({ path: '/roadOperation/allRoad' })
            } else {
              this.$message({
                message: response.message,
                type: 'error',
                duration: 10000,
                showClose: true
              })
            }
          } catch (error) {
            throw new Error(error)
          }
        } else {
          this.loading = false
          this.$message.error(this.$t('login.validfaild'))
        }
      })
    },
    forgetHandle() {
      this.$message.success(this.$t('login.pwdChanged'))
      this.wrapSwitch(true)
    }
  }
}
</script>

<style lang="stylus">
.ieDia {
  margin-top: -20px;

  .ieTl {
    font-size: 28px;
    margin-bottom: 20px;
    color: #000;
  }

  .ieCon {
    font-size: 16px;
  }

  .itPic {
    text-align: center;
  }

  .itPic img {
    width: 90px;
    height: auto;
    margin: 20px;
    margin-bottom: 0;
  }
}

.r-f {
  .el-form-item.is-success .el-input__inner {
    border-color: #409EFF;
  }

  .el-button:hover {
    color: #409EFF;
    background: #ffffff;
    border-color: #409EFF;
  }
}

.forget-form, .login-form {
  .el-form-item__content {
    line-height: 40px;
  }

  .el-input__inner {
    padding-top: 2px;
    height: 40px;
    line-height: 40px;
  }
}

.minw {
  min-width: 1000px;
  overflow: auto;
}

.btn button {
  width: 100%;
  padding: 12px 20px;
}
.login-page .el-dialog {
  width: 600px !important;
  margin-top:15% !important;
}
.login-page .el-dialog__headerbtn{
  display: none;
}
</style>
<style lang="stylus" scoped>
@import '../../assets/styl/variables.styl';

.left-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  background: #fff;
  cursor: pointer;
  font-size: 30px;
  color: #238ad5;
  display: flex;
  font-weight: 600;
  align-items: center;

  img {
    border-style: none;
    height: 35px;
    margin-left: 60px;
    margin-right: 20px;
  }
}

.login-col {
  height: 100%;
}


.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  min-width: 1100px;
  background: #0C1B25;
  overflow: auto;
  background-position: left 75px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lang {
    position: absolute;
    right: 59px;
    top: 24px;
  }

  .svg-github {
    position: absolute;
    right: 29px;
    top: 25px;
  }

  .translate-left, .translate-right {
    will-change: auto;
    transform: translateX(0px);
    transition: transform 0.6s ease-in-out;
  }

  .switch-left {
    transform: translateX(525px);
  }

  .switch-right {
    transform: translateX(-375px);
  }
}

.login-wrap {
  position: absolute;
  right: 150px;
  top: 50%;
  overflow: hidden;
  width: 400px;
  height: 360px;
  margin-top: -200px;
  transform: translateY(-10px);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

  .l-title {
    color: #ffffff;
    font-size: 24px;
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }

  .login-box {
    width: 100%;
    border-radius: 4px;
    background: white;
    height: 100%;
  }

  .logo {
    padding-top: 26px;
    text-align: center;
  }

  .el-button--primary {
    background-image: linear-gradient(-90deg, #2daaff 2%, #5a74fc 98%);
  }

  .title {
    font-weight: bold;
    color: main-color;
    padding-top: 8px;
    color: #478BFD;
    font-size: 22px;

    a {
      cursor: cell;
    }

    a:before {
      content: '[';
      opacity: 0;
      margin-right: 10px;
      transform: translateX(-10px);
      transition: transform 0.2s, opacity 0.2s;
    }

    a:after {
      content: ']';
      opacity: 0;
      margin-left: 10px;
      transform: translateX(10px);
      transition: transform 0.2s, opacity 0.2s;
    }

    a:hover:before, a:hover:after {
      opacity: 1;
      transform: translateX(0);
    }

    .subtitle {
      color: sub-color;
    }
  }

  .forgetwrap-title {
    padding-top: 30px;
    padding-left: 15px;
  }

  .forget-form {
    padding: 20px 30px 30px;
    padding-bottom: 0;
  }

  .login-form {
    padding: 30px;
    padding-bottom: 0;
  }

  .login-footer {
    padding: 0 30px;

    .forgetpwd {
      text-align: right;

      span {
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #606266;
      }
    }
  }

  .wallpaper {
    // width 100%
    // height 100%
    // background url('../../assets/images/login_bag.png')
    // background-size cover
    // position relative
  }
}
</style>
